import { useEffect, useState } from "react";

import { Table } from "../../../../../../Components/FinalTable";

import THeader from "./THeader";

import TBody from "./TBody";

import TInfo from "./TInfo";

import TContext from "./TContext";

import { TableTopBar } from "../../../../../../Components/FinalTable";

import BtnRounded from "../../../../../../Components/Buttons/BtnRounded";

import { useNavigate, useParams } from "react-router-dom";

import useApp from "../../../../../../Hooks/useApp";

import useAxios from "../../../../../../Hooks/useAxios";

import InvCart from "./InvCart";

const LiveData = ({ showLive, setShowLive }) => {
  const [openCart, setOpenCart] = useState(false);
  const [cartItems, setCartItems] = useState(0);
  const [checked_id, setCheckedId] = useState(-1);
  const { id } = useParams();
  const navigate = useNavigate();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortField, setSortField] = useState("created_at");
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPrevPage, setHasPrevPage] = useState(false);
  const [data, setData] = useState([]);
  const [showPagination, setShowPagination] = useState(true);
  const [filters, setFilters] = useState({});

  const [tableIsLoading, setTableIsLoading] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);

  const [searchInput, setSearchInput] = useState("");
  const [visitId, setVisitId] = useState(0);
  const request = useAxios();
  const { setShowFormModal, setModalMessage, setShowSuccessModal, user } =
    useApp();

  const [docs, setDocs] = useState([]);

  const [cartData, setCartData] = useState({});

  useEffect(() => {
    getInitDiagnosis(1, "created_at", "desc", filters);
  }, [limit]);

  useEffect(() => {
    if (searchInput.length < 3) return;

    async function search() {
      setTableIsLoading(true);

      let res = await request({
        method: "GET",
        url: "diagnosis/search",
        params: {
          value: searchInput,
        },
      });
      if (res === "network-error" || res === "error") {
        navigate("/dashboard/user-queue");
        return;
      }

      setShowLive(true);
      setData(res);

      setShowPagination(false);
      setIsFiltered(true);
      setTableIsLoading(false);
    }

    search();
  }, [searchInput]);

  async function getInitDiagnosis(
    page = 1,
    sort_field = "created_at",
    sort_order = "desc",
    filters = {},
  ) {
    setTableIsLoading(true);
    let res = await request({
      method: "GET",
      url: `diagnosis/list`,
      params: {
        page,
        limit,
        sort_field: sort_field,
        sort_order: sort_order,
        ...filters,
      },
      network_error: false,
    });

    if (res === "network-error" || res === "error") {
      navigate("/dashboard/user-queue");
      return;
    }

    setTableIsLoading(false);
    setData(res.docs);
    setHasNextPage(res.hasNextPage);
    setHasPrevPage(res.hasPrevPage);
  }
  useEffect(() => {
    async function Initialize() {
      let res = await request({
        method: "GET",
        url: `hospital/records/consultation?visit_step_id=${id}`,
      });

      if (res === "network-error" || res === "error") {
        navigate("/dashboard/user-queue");
        return;
      }

      setVisitId(res.visit.id);
    }

    Initialize();
  }, []);
  async function handleNext() {
    if (hasNextPage) {
      setPage(page + 1);
      getInitDiagnosis(page + 1, sortField, sortOrder);
    }
  }

  async function handlePrev() {
    if (hasPrevPage) {
      setPage(page - 1);
      getInitDiagnosis(page - 1, sortField, sortOrder);
    }
  }

  async function handleFilterQuery(filters) {
    setSortField("created_at");
    setSortOrder("desc");
    getInitDiagnosis(1, "created_at", "desc", filters);

    setIsFiltered(true);
    setFilters(filters);
  }

  async function handleHeaderQuery(field, order) {
    setPage(1);
    setSortOrder(order);
    setSortField(field);
    getInitDiagnosis(1, field, order);
  }

  async function handleClearFilters() {
    await getInitDiagnosis(1, "created_at", "desc");
    setPage(1);
    setSortField("created_at");
    setSortOrder("desc");
    setIsFiltered(false);
    setShowPagination(true);
    setSearchInput("");
  }

  // function for adding multiple Investigations
  const [selected, setSelected] = useState();

  async function AddInv() {
    let keys = Object.keys(cartData);
    let selectedDocs = [];

    for (let key of keys) {
      let singleItem = cartData[key];
      selectedDocs.unshift(singleItem);
    }
    setSelected(selectedDocs);

    if (selectedDocs.length === 0) {
      setModalMessage("Select at least one investigation");
      setShowFormModal(true);
      return;
    }

    let ids = selectedDocs.map((item) => ({
      id: item.id,
    }));

    let res = await request({
      method: "POST",
      url: "diagnosis/visit/add/multi",
      data: {
        visit_id: parseInt(visitId),
        ids: ids,
        requested_by: parseInt(user.id),
      },
    });

    if (res !== "error") {
      setModalMessage("Diagnosis Added");
      setShowSuccessModal(true);
      navigate(`/dashboard/attend/${id}`);
    }
  }

  useEffect(() => {}, [id]);

  return (
    <TContext.Provider
      value={{
        showLive,
        limit,
        setLimit,
        data,
        page,
        hasNextPage,
        hasPrevPage,
        handleNext,
        handlePrev,
        handleHeaderQuery,
        handleFilterQuery,
        isFiltered,
        handleClearFilters: handleClearFilters,
        total: "...",
        setIsFiltered,
        showPagination,
        resetQuery: handleClearFilters,
        checked_id,
        setCheckedId,
        cartItems,
        setCartItems,
        cartData,
        setCartData,
        docs,
        setDocs,
      }}
    >
      <div className="px-7 pb-8">
        <TableTopBar
          mt={2}
          mb={2}
          showAdd={false}
          showCart={true}
          changes={0}
          cartCount={Object.keys(cartData).length}
          handleLiveStream={() => {}}
          CartClick={() => setOpenCart(true)}
          isFiltered={isFiltered}
          handleClearFilters={handleClearFilters}
          tableIsLoading={tableIsLoading}
          showReport={false}
          showFilter={false}
          searchInput={searchInput}
          setSearchInput={setSearchInput}
        />
        <Table>
          <THeader />
          <TBody />
          <TInfo />
          <div className="max-w-2xl w-full mx-auto">
            <BtnRounded mt={2} click={() => AddInv()} className="btn">
              <span className=" font-pop-reg">Add Diagnosis</span>
              <span className="px-3 font-normal text-2xl"></span>
            </BtnRounded>
          </div>
        </Table>
        {openCart && (
          <InvCart
            showCart={openCart}
            setShowCart={setOpenCart}
            cartData={cartData}
            setCartData={setCartData}
            add={() => AddInv()}
          />
        )}
      </div>
    </TContext.Provider>
  );
};

export default LiveData;
